import { defineMessages } from 'react-intl';

const messages = defineMessages({
  exitLearnerView: {
    id: 'SideNavbar.exitLearnerView',
    defaultMessage: 'Exit Learner View',
    description: 'A message shown in case when the user is in learner view and wants to exit.',
  },
  viewProfile: {
    id: 'SideNavbar.viewProfile',
    defaultMessage: 'View profile',
    description: 'A message shown in case when the user wants to view their profile.',
  },
  switchToLearner: {
    id: 'SideNavbar.switchToLearner',
    defaultMessage: 'Switch to Learner',
    description: 'A message shown in case when the user wants to switch to learner view.',
  },
  organizations: {
    id: 'SideNavbar.organizations',
    defaultMessage: 'Organizations',
    description: 'A message shown in case when the user wants to view their organizations.',
  },
  admin: {
    id: 'SideNavbar.admin',
    defaultMessage: 'Admin',
    description: 'A message shown in case when the user is an admin.',
  },
  staff: {
    id: 'SideNavbar.staff',
    defaultMessage: 'Staff',
    description: 'A message shown in case when the user is a staff.',
  },
  learner: {
    id: 'SideNavbar.learner',
    defaultMessage: 'Learner',
    description: 'A message shown in case when the user is a learner.',
  },
  logout: {
    id: 'SideNavbar.logout',
    defaultMessage: 'Log out',
    description: 'A message shown for the logout button.',
  },
});

export default messages;
